export default "__VITE_ASSET__23b3ebf3__"